import { render } from "./Flags.vue?vue&type=template&id=71d17234"
import script from "./Flags.vue?vue&type=script&lang=js"
export * from "./Flags.vue?vue&type=script&lang=js"

import "./Flags.vue?vue&type=style&index=0&id=71d17234&lang=less"

import exportComponent from "/codebuild/output/src3271881597/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__